/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { observer } from 'mobx-react'
import { compose } from 'recompose'

import Household from './list'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
		}
	}

	render() {
		
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-12">
						<div className="page-title-box">
							<div className="page-title-right">
								<ol className="breadcrumb m-0">
									<li className="breadcrumb-item"><Link to='/'>Dashboard</Link></li>
									<li className="breadcrumb-item"><a href='javascript:void(0)'>Resident Profiling</a></li>
									<li className="breadcrumb-item active">Household</li>
								</ol>
							</div>
							<h4 className="page-title">Household</h4>
						</div>
					</div>
				</div>
				<div className="row" style={{ minHeight: '600px' }}>
					<div className="col-12">
						<div className='card'>
							<div className='card-body'>
								<Household />
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		)
	}
}

const composed = compose(
	observer
)

export default composed(Index)
